// extracted by mini-css-extract-plugin
export default {"messages-container":"ChatMessages_messages-container__cIFUX","messages-wrapper":"ChatMessages_messages-wrapper__mwu71","hint":"ChatMessages_hint__XB59u"};